import { create } from "zustand";
import api from "./api";

interface User {
  email: string;
  name: string;
  picture: string;
}

interface AuthState {
  user: User | null;
  loading: boolean;
  login: (credential: string) => Promise<void>;
  logout: () => void;
  restore: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,

  login: async (credential) => {
    set({ loading: true });
    try {
      const { data } = await api.post("/auth/google", { credential });
      localStorage.setItem("ssn_token", data.access_token);
      localStorage.setItem("ssn_user", JSON.stringify(data.user));
      set({ user: data.user });
    } finally {
      set({ loading: false });
    }
  },

  logout: () => {
    localStorage.removeItem("ssn_token");
    localStorage.removeItem("ssn_user");
    set({ user: null });
  },

  restore: () => {
    const raw = localStorage.getItem("ssn_user");
    if (raw) {
      try { set({ user: JSON.parse(raw) }); } catch { /* ignore */ }
    }
  },
}));
